var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0533 18.0668C23.4933 18.6135 23.1733 19.4002 23.2533 20.2402C23.3733 21.6802 24.6933 22.7335 26.1333 22.7335H28.6666V24.3202C28.6666 27.0802 26.4133 29.3335 23.6533 29.3335H8.34659C5.58659 29.3335 3.33325 27.0802 3.33325 24.3202V15.3468C3.33325 12.5868 5.58659 10.3335 8.34659 10.3335H23.6533C26.4133 10.3335 28.6666 12.5868 28.6666 15.3468V17.2668H25.9732C25.2266 17.2668 24.5466 17.5601 24.0533 18.0668Z",
    stroke: "#2C625F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 16.5467V10.4535C3.33325 8.86681 4.30659 7.45341 5.78659 6.89341L16.3733 2.89341C18.0266 2.26675 19.7999 3.49345 19.7999 5.26679V10.3334",
    stroke: "#2C625F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0783 18.6268V21.3735C30.0783 22.1069 29.4917 22.7068 28.745 22.7335H26.1317C24.6917 22.7335 23.3717 21.6802 23.2517 20.2402C23.1717 19.4002 23.4917 18.6135 24.0517 18.0668C24.545 17.5601 25.225 17.2668 25.9717 17.2668H28.745C29.4917 17.2935 30.0783 17.8935 30.0783 18.6268Z",
    stroke: "#2C625F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 16H18.6666",
    stroke: "#2C625F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWallet);
export default __webpack_public_path__ + "static/media/empty-wallet.2638a628b7cdaa877480aa053cf98ec4.svg";
export { ForwardRef as ReactComponent };